export default function initModalRoot() {
  if (typeof document === 'undefined') return;
  if (!document.getElementById('modal-root')) {
    const div = document.createElement('div');
    div.id = 'modal-root';
    document.body.appendChild(div);
  }
}
